(() => {
  'use strict';
  const ATTRIBUTION_KEY = 'veloure_attribution_v1';
  const ENTRY_KEY = 'veloure_reservation_entry_v1';

  function safeParse(value) {
    try { return JSON.parse(value); } catch (_) { return {}; }
  }

  function saveAttribution() {
    const params = new URLSearchParams(window.location.search);
    const previous = safeParse(localStorage.getItem(ATTRIBUTION_KEY));
    const next = { ...previous };
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid','ttclid'].forEach(key => {
      const value = params.get(key);
      if (value) next[key] = value;
    });
    if (!next.first_landing_page) next.first_landing_page = window.location.href;
    if (!next.first_referrer) next.first_referrer = document.referrer || '';
    next.latest_landing_page = window.location.href;
    next.referrer = document.referrer || next.referrer || '';
    localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(next));
  }

  saveAttribution();

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-vel-reservation-start]');
    if (!link) return;
    const entry = {
      clicked_at: new Date().toISOString(),
      source: 'cart_drawer',
      page_url: window.location.href,
      entry_id: `ENT-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2,7).toUpperCase()}`
    };
    localStorage.setItem(ENTRY_KEY, JSON.stringify(entry));
    try {
      window.Shopify?.analytics?.publish?.('veloure_reservation_entry_clicked', entry);
    } catch (_) {}
  });
})();
